import { compose } from 'redux';
import { connect } from 'react-redux';
import selectors from '../../../../rootSelectors';
import AvatarView from '../../../../common/avatar/avatarView';
import withAvatar from '../../../../common/avatar/withAvatar';
import VocabFITBView from '../../VocabFITBView';
import { stopAudio, narrateReset } from '../../../../common/audio/audioActions';
import { narrateStimulus, resetSelectedIndex } from '../../../../common/questions/questionsActions';
import { unmountScreen } from '../../../../common/screen/screenActions';
import { onResponseSelect } from '../../../vocabActions';
import { fetchVocabFITBContent } from '../../vocabFITBActions';
import { narratePracticeScreen, onNextPracticeButtonClick } from './VocabFITBPracticeActions';
import { PRACTICE } from '../../../../constants/assessmentItemType';
import { VOCAB_AUDIO_INSTRUCTIONS } from '../../../vocabConstants';
import { getAvatarPosition } from '../../../../common/alex/AlexUtils';

const mapStateToProps = state => ({
    isDataFetched: selectors.getIsVocabFITBDataFetched(state),
    stimulus: selectors.getVocabFITBStimulusInfo(state, PRACTICE),
    possibleResponses: selectors.getVocabFITBPossibleResponses(state, PRACTICE),
    isScreenBlocked: selectors.getIsScreenBlocked(state),
    isScreenGreyedOut: selectors.getIsScreenGreyedOut(state),
    isStimulusPlaying: selectors.getIsStimulusPlaying(state),
    isNextButtonActive: selectors.getIsNextButtonActive(state),
    selectedResponse: selectors.getSelectedIndex(state),
    maxResponseLength: selectors.getMaxResponseLength(state, PRACTICE),
});

const mapDispatchToProps = dispatch => ({
    fetchContent: () => {
        dispatch(fetchVocabFITBContent());
    },
    narrateScreen: stimulusAudio => dispatch(narratePracticeScreen(stimulusAudio)),
    playStimulus: stimulusAudio => dispatch(narrateStimulus(stimulusAudio)),
    selectResponse: response => dispatch(onResponseSelect(response)),
    onNext: () => dispatch(onNextPracticeButtonClick()),
    cleanup: () => {
        dispatch(stopAudio());
        dispatch(narrateReset());
        dispatch(resetSelectedIndex());
        dispatch(unmountScreen());
    },
});

const avatarMapStateToProps = state => {
    const positionConfig = {
        alyxPosition: AvatarView.Position.TOP_HEADER_CENTER,
        defaultViewPosition: AvatarView.Position.MIDDLE_LEFT,
    };
    const position = getAvatarPosition(positionConfig);
    return {
        position,
        animateAlex: true,
        instructions:
            VOCAB_AUDIO_INSTRUCTIONS[selectors.getCurrentLanguage(state)]
                .vocabFITBInstructionReplay,
    };
};

const VocabFITBPracticeContainer = compose(
    connect(mapStateToProps, mapDispatchToProps),
    withAvatar(avatarMapStateToProps),
)(VocabFITBView);

export default VocabFITBPracticeContainer;
